<div class="overview-product_size"
     [style.min-height.px]="componentHeight === 0 ?'auto':componentHeight">
	<div class="order-overview-table_icon-text">
		<svg class="icon-potsize" height="11" viewBox="0 0 16 11" width="16">
			<use xlink:href="/images/icons/svg-sprite.svg#potsize"></use>
		</svg>
		<span>{{potSize || "-"}}</span>
	</div>

	<div class="order-overview-table_icon-text">
		<svg class="icon-potheight" height="11" viewBox="0 0 6 11" width="6">
			<use xlink:href="/images/icons/svg-sprite.svg#potheight"></use>
		</svg>
		<span>{{height || "-"}}</span>
	</div>
</div>
